<template>
    <div
        v-if="showAddDialog"
        class="dialog-mask">
        <div class="add-user-area">
            <div class="add-user-title">
                添加商户
            </div>
            <a-input-group size="large">
                <div class="input-line">
                    <div class="input-label">
                        老板名字
                    </div>
                    <a-input
                        v-model="bossName"
                        placeholder="请输入老板名字 (必填)" />
                </div>
                <div class="input-line">
                    <div class="input-label">
                        老板电话
                    </div>
                    <a-input
                        v-model="bossPhone"
                        placeholder="请输入老板电话号码 (必填)" />
                </div>
                <div class="input-line">
                    <div class="input-label">
                        商户简称
                    </div>
                    <a-input
                        v-model="shopName"
                        placeholder="请从微信子商户拷贝商户简称" />
                </div>
                <div class="input-line">
                    <div class="input-label">
                        企业全称
                    </div>
                    <a-input
                        v-model="companyName"
                        placeholder="请从微信子商户拷贝企业全称" />
                </div>
                <div class="input-line">
                    <div class="input-label">
                        商户号
                    </div>
                    <a-input
                        v-model="wxMchId"
                        placeholder="请从微信子商户拷贝微信商户号" />
                </div>
                <div class="input-line">
                    <div class="input-label">
                        支付模板号
                    </div>
                    <a-input
                        v-model="wxPlanId"
                        placeholder="请从微信子商户拷贝微信支付模板号" />
                </div>
            </a-input-group>
            <div
                class="message"
                v-if="showError">
                {{ showMessage }}
            </div>
            <div class="submit-button-area">
                <a-button
                    v-on:click="addConfirm"
                    class="submit-button"
                    size="large">
                    创建
                </a-button>
                <a-button
                    v-on:click="addConfirmAndContinue"
                    class="submit-button"
                    size="large"
                    type="primary">
                    创建并继续
                </a-button>
            </div>
            <a-icon
                v-on:click="addCancel"
                class="close-button"
                type="close" />
        </div>
    </div>
</template>
<script>
 import Vue from 'vue';

 import { isEmptyOrWhitespace, isNumber, isPhoneNumber } from "../util/utils.js"
 import message from "ant-design-vue/lib/message";

 import InputGroup from "ant-design-vue/lib/input/Group";
 import Input from "ant-design-vue/lib/input/Input";

 Vue.component(InputGroup.name, InputGroup);
 Vue.component(Input.name, Input);

 export default {
     name: 'AddMerchantDialog',
     data() {
         return {
             showAddDialog: false,
             showError: false,
             addUserError: false,
             showMessage: "",
             bossPhone: "",
             bossName: "",
             shopName: "",
             companyName: "",
             wxMchId: "",
             wxPlanId: "",
         }
     },
     components: {
     },
     props: {
     },
     computed: {
     },
     methods: {
         show() {
             this.init()
             this.showAddDialog = true
         },
         init() {
             this.showError = false
             this.showMessage = ""
             this.bossPhone = ""
             this.bossName = ""
             this.shopName = ""
             this.companyName = ""
             this.wxMchId = ""
             this.wxPlanId = ""
         },
         addCancel() {
             this.showAddDialog = false
         },
         addConfirm() {
             if (this.confirmInput()) {
                 var that = this
                 this.addUser(
                     function() {
                         that.showAddDialog = false

                         message.success("用户已经添加成功")
                     },
                     function(errorCode) {
                         that.showError = true
                         that.showMessage = "错误码：" + errorCode
                     }
                 )
             }
         },
         addConfirmAndContinue() {
             if (this.confirmInput()) {
                 var that = this

                 this.addUser(
                     function() {
                         that.init()
                         that.showAddDialog = true

                         message.success("用户已经添加成功")
                     },
                     function(errorCode) {
                         that.showError = true
                         that.showMessage = "错误码：" + errorCode
                     }
                 )
             }
         },
         confirmInput() {
             if (isEmptyOrWhitespace(this.bossPhone)) {
                 this.showError = true
                 this.showMessage = "请输入老板电话"
                 return false
             } else if (isEmptyOrWhitespace(this.bossName)) {
                 this.showError = true
                 this.showMessage = "请输入老板名字"
                 return false
             } else if (!isEmptyOrWhitespace(this.bossPhone) && !isPhoneNumber(this.bossPhone)) {
                 this.showError = true
                 this.showMessage = "老板电话不正确"
                 return false
             } else if (!isEmptyOrWhitespace(this.wxMchId) && !isNumber(this.wxMchId)) {
                 this.showError = true
                 this.showMessage = "微信商户号不是一个合法的数字"
                 return false
             } else if (!isEmptyOrWhitespace(this.wxPlanId) && !isNumber(this.wxPlanId)) {
                 this.showError = true
                 this.showMessage = "微信支付模板号不是一个合法的数字"
                 return false
             } else {
                 this.showError = false
                 this.showMessage = ""
                 return true
             }
         },
         addUser(successCallback, failedCallback) {
             this.addUserError = false

             var url = process.env.VUE_APP_API_SERVER + '/business'
             var accessToken = localStorage.getItem('accessToken')
             var data = {
                 Username: this.bossName,
                 Phone: this.bossPhone,
                 ShopName: this.shopName,
                 CompanyName: this.companyName,
                 WxMchId: this.wxMchId,
                 WxPlanId: parseInt(this.wxPlanId)
             }

             var that = this
             fetch(url, {
                 method: "POST",
                 body: JSON.stringify(data),
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }).then(res => {
                 if (!res.ok) {
                     console.log("****** ", res)

                     throw res
                 }

                 return res.json()
             }).then(response => {
                 console.log("!!!!! ", response)
                 if (!that.addUserError) {
                     successCallback()
                 } else {
                     that.addUserError = false
                 }
             }).catch(error => {
                 that.addUserError = true

                 console.log("###### ", error, error.body)

                 failedCallback(error.status)
             })
         }
     },
 }
</script>

<style scoped>
 .dialog-mask {
     position: absolute;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     background-color: rgba(0, 0, 0, 0.8);
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     z-index: 1000;
 }
 .add-user-area {
     padding: 30px;
     background-color: #FFF;
     border: 1px solid #DDD;
     border-radius: 5px;
     box-shadow: 0px -5px 10px -10px #858484;
     width: 450px;
     height: 550px;
     position: absolute;
     display: flex;
     flex-direction: column;
     align-items: center;
 }
 .add-user-title {
     font-size: 24px;
     margin-bottom: 40px;
 }
 .submit-button-area {
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     align-items: center;
 }
 .submit-button {
     width: 150px;
     margin-left: 10px;
     margin-right: 10px;
 }
 .input-area {
     width: 100%;
 }
 .input-line {
     width: 100%;
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-top: 10px;
 }
 .input-label {
     width: 120px;
     font-size: 16px;
     margin-right: 10px;
     text-align: start;
 }
 .close-button {
     position: absolute;
     top: 10px;
     right: 10px;
     cursor: pointer;
     color: #AAA;
 }
 .close-button:hover {
     color: #666;
 }
 .message {
     margin-top: 10px;
     color: #D80E3B;
     font-size: 14px;
 }
</style>
